import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-header" }
const _hoisted_3 = { class: "popup-title" }
const _hoisted_4 = { class: "popup-content" }
const _hoisted_5 = { class: "popup-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_gs_button = _resolveComponent("gs-button")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    width: "700",
    persistent: "",
    fullscreen: _ctx.isMobile,
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.onUpdate
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("button", {
            class: "popup-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
          }, [
            _createVNode(_component_v_icon, { size: 32 }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("mdi-close")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "content", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_gs_button, {
            disabled: _ctx.loading,
            loading: _ctx.loading,
            "full-width": "",
            size: "large",
            type: "primary",
            onClick: _ctx.primaryButtonAction
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.primaryButtonText), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"]),
          (_ctx.secondaryButtonText)
            ? (_openBlock(), _createBlock(_component_gs_button, {
                key: 0,
                disabled: _ctx.loading,
                loading: _ctx.loading,
                class: "mt-2",
                "full-width": "",
                type: "info",
                size: "large",
                onClick: _ctx.secondaryButtonAction
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.secondaryButtonText), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }, 8, ["fullscreen", "model-value", "onUpdate:modelValue"]))
}